import React from "react";
const PersonnelBox = ({ text = [], name, position }) => {
  return (
    <div className="personnel-wrapper">
      <div className="box-header">
        <h2 className="personnel-name">{name}</h2>
        <h3 className="personnel-position">{position}</h3>
      </div>
      {text.map((t, index) => (
        <p className="personnel-text" key={index}>
          {t}
        </p>
      ))}
    </div>
  );
};
export default PersonnelBox;
